@if(context() === 'offers') {
@if(flexextraFS || flexextraCS || flexextraCR) {
<div class="flex-wrapper">
    <div class="item-wrapper">
        @if(flexextraFS || flexextraCS || flexextraCR) {
        <span multilang class="badg">{{'Flexibel'}}</span>
        <span multilang class="item-text">{{'Stornieren/Umbuchen'}}</span>
        }
    </div>
    <div class="item-body">
        @if(!currentPartner?.filters?.hideflexiblefilterCS && flexextraCS) {
        <!-- <button class="shois" (click)="onChange(flexs.fts);checkflexextraFS();" matRipple> -->
        <button class="shois" (click)="checkflexextraCS();" matRipple>
            <mat-icon class="tour-item-icon">{{(flexextraCSChecked) ? 'check_box' :
                'check_box_outline_blank'}}</mat-icon>
            <div class="flxccs">
                <span multilang class="tour-item-name">{{'flexibel stornierbar'}}</span>
                <span multilang class="bestprcit">ab {{flexextraCSVal.bestPricePerPerson?.value + ' ' +
                    flexextraCSVal.bestPricePerPerson?.currency}} p.P.</span>
            </div>
        </button>
        }
        <!-- <ng-container *ngIf="showFTS">
                                </ng-container> -->
        @if(!currentPartner?.filters?.hideflexiblefilterFS && flexextraFS) {

        <!-- <button class="shois" (click)="onChange(flexs.ftu)" matRipple> -->
        <button class="shois" (click)="checkflexextraFS()" matRipple>
            <mat-icon class="tour-item-icon">{{(flexextraFSChecked) ?
                'check_box' : 'check_box_outline_blank'}}</mat-icon>
            <div class="flxccs">
                <span multilang class="tour-item-name">{{'kostenfrei stornierbar'}}</span>
                <span multilang class="bestprcit">{{'ab'}} {{flexextraFSVal?.bestPricePerPerson?.value + ' ' +
                    flexextraFSVal?.bestPricePerPerson?.currency}} p.P.</span>
            </div>
        </button>
        }
        @if(!currentPartner?.filters?.hideflexiblefilterCR && flexextraCR) {

        <!-- <button class="shois" (click)="onChange(flexs.ftu)" matRipple> -->
        <button class="shois" (click)="checkflexextraCR()" matRipple>
            <mat-icon class="tour-item-icon">{{(flexextraCRChecked) ?
                'check_box' : 'check_box_outline_blank'}}</mat-icon>
            <div class="flxccs">
                <span multilang class="tour-item-name">{{'Corona-Reiseschutz'}}</span>
                @if(flexextraCR) {
                <span multilang class="bestprcit">{{'ab'}} {{flexextraCRVal.bestPricePerPerson?.value + ' ' +
                    flexextraCRVal.bestPricePerPerson?.currency}} p.P.</span>
                }
            </div>
        </button>
        }
        <!-- <ng-container *ngIf="showFTU">
                                </ng-container> -->
    </div>

    <ng-container *ngTemplateOutlet="specialtemplate"></ng-container>
</div>
}
} @else {
<div class="flex-wrapper">
    <div class="item-wrapper">
        <span multilang class="badg">{{'Flexibel'}}</span>
        <span multilang class="item-text">{{'Stornieren/Umbuchen'}}</span>
    </div>
    <div class="item-body">
        @if(!currentPartner?.filters?.hideflexiblefilterCS) {
        <button class="shois" (click)="checkflexextraCS();" matRipple>
            <mat-icon class="tour-item-icon">{{(flexextraCSChecked) ? 'check_box' :
                'check_box_outline_blank'}}</mat-icon>
            <div class="flxccs">
                <span multilang class="tour-item-name">{{'flexibel stornierbar'}}</span>
            </div>
        </button>
        }
        @if(!currentPartner?.filters?.hideflexiblefilterFS) {
        <button class="shois" (click)="checkflexextraFS()" matRipple>
            <mat-icon class="tour-item-icon">{{(flexextraFSChecked) ?
                'check_box' : 'check_box_outline_blank'}}</mat-icon>
            <div class="flxccs">
                <span multilang class="tour-item-name">{{'kostenfrei stornierbar'}}</span>
            </div>
        </button>
        }
        @if(!currentPartner?.filters?.hideflexiblefilterCR) {
        <button class="shois" (click)="checkflexextraCR()" matRipple>
            <mat-icon class="tour-item-icon">{{(flexextraCRChecked) ?
                'check_box' : 'check_box_outline_blank'}}</mat-icon>
            <div class="flxccs">
                <span multilang class="tour-item-name">{{'Corona-Reiseschutz'}}</span>
            </div>
        </button>
        }
    </div>
    <ng-container *ngTemplateOutlet="specialtemplate"></ng-container>
</div>
}




<ng-template #specialtemplate>
    @if(specials?.length > 0) {
    <div class="item-wrapper">
        <span multilang class="badgs">{{'Specials'}}</span>
        <span multilang class="item-text">{{'Veranstalter-Aktionen'}}</span>
    </div>
    <div class="item-body">
        <ng-container *ngFor="let spec of specials">
            <button class="shois" (click)="onChange(spec)" matRipple>
                <mat-icon class="tour-item-icon">{{spec.checked ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                <span multilang class="tour-item-name">{{spec?.name}}</span>
                <mat-icon class="item-info-icon" *ngIf="spec?.tooltip?.length > 0" matTooltipPosition="above"
                    [matTooltip]="spec.tooltip" matTooltipClass="matTooltip">info</mat-icon>
            </button>
        </ng-container>
    </div>
    }
</ng-template>